/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import React from 'react';
import Cookies from 'universal-cookie';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
/* NPM Imports End */

/* Project Imports Start */
import { publicRoutes as routes } from './app-routes';
/* Project Imports End */

/* CCS & Image imports Start */

/* CCS & Image imports End */

const NotAuthenticatedContent = function() {
  const location = useLocation();
  const cookies = new Cookies();

  if (location && location.pathname.includes('reportViewer')) {
    cookies.set('linkNavigationUrl', window.location.href);
  }
  if (window.location && window.location.href.includes('FileViewer')) {
    cookies.set('linkNavigationUrl', window.location.href);
  }
  return (
    <Switch>
      {routes.map(({ path, component }) => (
        <Route exact key={path} path={path} component={component} />
      ))}
      {window.location.pathname.includes('oauth-callback')
        ? (window.location = '/#/oauth-callback' + window.location.search)
        : null}
      {window.location &&
      window.location.href.includes('FileViewer') &&
      !cookies.get('token') ? (
        window.location.replace(cookies.get('linkNavigationUrl', '_self'))
      ) : (
        <Redirect to={'/login'} />
      )}
    </Switch>
  );
};

NotAuthenticatedContent.displayName = 'NotAuthenticatedContent';

export default NotAuthenticatedContent;
